import type { ApolloError, MutationFunctionOptions } from '@apollo/client';
import { Formik } from 'formik';
import { CONSTANTS } from '../../constants';
import { loginInitialState } from '../../initial-states/userSignUp.initialState';
import { LoginSchema } from '../../yupValidationSchemas/loginSchema';
import AuthHeader from '../AuthHeader/AuthHeader';
import ErrorBlock from '../ErrorBlock/ErrorBlock';
import { handleSubmitData } from './handlers/submitData.handler';
import { LoginFormRender } from './LoginFormRender';

interface RenderUserLoginProps {
  error: ApolloError | undefined;
  dashboardRoute: string;
  loading: boolean;
  loginUser: (options?: MutationFunctionOptions) => Promise<any>;
}

export const RenderUserLogin = (props: RenderUserLoginProps) => {
  const { error, dashboardRoute, loading, loginUser } = props;

  return (
    <div className="LoginUser__Grid">
      <div className="LoginUser__Wrapper">
        <AuthHeader
          header={CONSTANTS.USER.LOGIN}
          login={true}
          styleName="LoginUser__Auth__HEADER"
        />
        <Formik
          initialValues={loginInitialState}
          validationSchema={LoginSchema}
          onSubmit={(values, actions) => {
            handleSubmitData(
              values,
              actions,
              dashboardRoute,
              loading,
              loginUser,
            );
          }}
        >
          {({ errors, touched, isValid }) => (
            <LoginFormRender
              errors={errors}
              touched={touched}
              valid={isValid}
              loading={loading}
            />
          )}
        </Formik>
      </div>
      <div className="Login__Right_Col">
        {error && <ErrorBlock error={error} />}
      </div>
    </div>
  );
};
